import { InternalError } from './internal.error';

export class InvalidPostalCodeError extends InternalError {
  constructor(postalCode: string, status?: number | null) {
    super('Invalid postal code', {
      status,
      data: { postalCode },
    });
  }
}
